/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

<script>
import AxiosSelect from '@base-inputs/AxiosSelect';
const prefix = 'Resources';
const Resource = a => `${prefix}/${a}`;

export default {
  name: 'LegalRequestsSelect',
  extends: AxiosSelect,
  props: {
    clearable: {
      default: () => false
    },
    value: {},
    axiosUrl: {
      default: () => Api.methods.resource.legalRequests
    }
  }
};
</script>
